import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserOutlined } from '@ant-design/icons';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { formatDate } from 'library/utilities/DateTime';
import '../../style.css';
var PersonalInformation = function (props) {
    var _a, _b, _c, _d;
    var t = props.translate, patient = props.patient;
    var birthdate = patient.getBirthdate();
    var birthAge = [
        birthdate ? formatDate(birthdate, 'D MMM YYYY') : '',
        patient.getAge() ? "(".concat(patient.getAge(), ")") : ''
    ]
        .filter(Boolean)
        .join(' ');
    var rows = [
        { label: t('patientInfo.name'), value: patient.getName() || '—' },
        {
            label: t('patientInfo.gender'),
            value: patient.getTranslatedGender() || '—'
        },
        {
            label: t('patientInfo.dobAge'),
            value: birthAge || '—'
        },
        {
            label: t('patientInfo.code'),
            value: patient.getCode() || '—',
            mono: true,
            chip: true
        },
        {
            label: t('patientInfo.systemCode'),
            value: patient.getSystemCode() || '—',
            mono: true
        },
        {
            label: t('patientInfo.mobile'),
            value: patient.getPrimaryPhone() || '—',
            mono: true
        },
        {
            label: t('patientInfo.area'),
            value: ((_b = (_a = patient.getPatientArea()) === null || _a === void 0 ? void 0 : _a.getName) === null || _b === void 0 ? void 0 : _b.call(_a)) || '—'
        },
        {
            label: t('patientInfo.registrationSource'),
            value: ((_d = (_c = patient.getPatientDetails()) === null || _c === void 0 ? void 0 : _c.getTranslatedRegistrationSource) === null || _d === void 0 ? void 0 : _d.call(_c)) || '—'
        }
    ];
    return (_jsxs("section", { className: "patient-profile__card", id: "profile-content", "data-onboarding": "patient-personal-info", children: [_jsxs("div", { className: "patient-profile__card-head", children: [_jsxs("div", { className: "patient-profile__card-title", children: [_jsx("span", { className: "patient-profile__card-icon is-sky", children: _jsx(UserOutlined, {}) }), _jsx("h2", { children: t('patientInfo.personalInfomation') })] }), _jsx("span", { className: "patient-profile__card-badge", children: t('patientInfo.demographics') })] }), _jsx("div", { className: "patient-profile__rows", children: rows.map(function (row) { return (_jsxs("div", { className: "patient-profile__row", children: [_jsx("span", { className: "patient-profile__row-label", children: row.label }), _jsx("span", { className: [
                                'patient-profile__row-value',
                                row.mono ? 'is-mono' : '',
                                row.chip && row.value !== '—' ? 'is-chip' : ''
                            ]
                                .filter(Boolean)
                                .join(' '), children: row.value })] }, row.label)); }) })] }));
};
export default localeTranslator(PersonalInformation, 'showPatient');
